import React, { useEffect, useRef, useState } from "react";
import "./ServicesPage.scss";
import "../../BigPages/ProdDropzone/AddProducts.css";
import Switch from "@mui/material/Switch";
import CustomTab from "../../../components/CustomTab/CustomTab";
import "../../../index.scss";
import { FormattedMessage } from "react-intl";
import ProductListPage from "../../Product/ProductListPage/ProductListPage";
import IconButton from "@mui/material/IconButton";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { CircularProgress, MenuItem, Select } from "@material-ui/core";
import SettingsIcon from '@mui/icons-material/Settings';
import FeedbackAlert from "../../../components/FeedbackAlert/FeedbackAlert";
import AddIcon from "@material-ui/icons/Add";
import Fab from "@material-ui/core/Fab";
import ProductCategoryListPage from "../../ProductCategory/ProductCategoryListPage/ProductCategoryListPage";
import ServiceListPage from "../ServiceListPage/ServiceListPage";
import ServiceCategoryListPage from "../../ServiceCategory/ServiceCategoryListPage/ServiceCategoryListPage";

const ServicesPage = () => {
    const [activateUpdatedSuccess, setActivateUpdatedSuccess] = useState(false);
    const [messageId, setMessageId] = useState("serviceUpdatedSuccess");

    function PopupMenu({ baseUrl, type = "service" }) {
        const [isActive, setIsActive] = useState(false);
        const menuRef = useRef(null);

        const onClick = () => {
            setIsActive(prevState => !prevState);
        };

        useEffect(() => {
            const handleClickOutside = (event) => {
                if (menuRef.current && !menuRef.current.contains(event.target)) {
                    setIsActive(false);
                }
            };

            if (isActive) {
                document.addEventListener('mousedown', handleClickOutside);
            }

            return () => {
                document.removeEventListener('mousedown', handleClickOutside);
            };
        }, [isActive]);

        const getButtonText = () => {
            if (type === "category") {
                return <FormattedMessage 
                    id="createServiceCategory" 
                    defaultMessage="Crear Categoría" 
                />;
            }
            return <FormattedMessage 
                id="createService" 
                defaultMessage="Crear Servicio" 
            />;
        };

        return (
            <div className="container" ref={menuRef}>
                <div className="menu-container">
                    <button onClick={onClick} className="menu-trigger">
                        <Fab size="small" className="fab" color="primary" aria-label="edit" style={{ backgroundColor: "#01A532" }}>
                            <AddIcon className="fab-icon" />
                        </Fab>
                    </button>
                    {isActive && (
                        <nav className="menu active">
                            <ul>
                                <li>
                                    <a href={`${baseUrl}/create`}>
                                        {getButtonText()}
                                    </a>
                                </li>
                            </ul>
                        </nav>
                    )}
                </div>
            </div>
        );
    }
    
    const components = [
        {
            navTitle: "servicesNav",
            component: <ServiceListPage />, 
            buttonComponenet: <PopupMenu baseUrl="servicios" type="service" />
        },
        {
            navTitle: "serviceCategoriesNav", 
            component: <ServiceCategoryListPage />, 
            buttonComponenet: <PopupMenu baseUrl="categorias-de-servicio" type="category" />
        },
    ];


    return (
        <div style={{flexGrow: "1", paddingTop: "1.5rem"}}>
            <main className="section-body-products scrolling">
                <div className="flex space row">
                    <div className="col-10">
                        <h1 className="section-title">
                            <FormattedMessage 
                                id="services" 
                                defaultMessage="Servicios" 
                            />
                        </h1>
                    </div>
                </div>
                
                <FeedbackAlert
                    idmessage={messageId}
                    open={activateUpdatedSuccess}
                    setOpen={setActivateUpdatedSuccess}
                />

                {components && <CustomTab props={components} />}
            </main>
        </div>
    );
};

export default ServicesPage; 